// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"InboundInfo_imageContainer__QJmj0","formContainer":"InboundInfo_formContainer__FXuKz"};